module.exports = __webpack_public_path__ + "img/empty_ofertas.65b461e1.svg";